import React from "react";
import SaadaImg1 from './images/saada1.jpg';
import SaadaImg2 from './images/saada2.jpg';
import SaadaImg3 from './images/saada3.jpg';

function EmpoweringWomen() {
  return (
    <>
    <section className="saada-section">
       
      <div className="saada-content">
        <h2>Empowering Women - Unleash Your Inner Strength</h2>
        <h3 style={{ textAlign: "center", fontWeight: "bold" }}>
          Wellness Workshop</h3>
        <h3 style={{ textAlign: "center", fontWeight: "bold", marginTop: "10px" }}>
          Saturday, October 18 - 🕕 6:00 PM - 8:00 PM</h3>
        
        <div style={{ textAlign: "center", fontWeight: "bold", marginBottom: "20px", direction: "rtl" }}>
          امنحي نفسك ساعتين من الصفاء والإبداع، لحظات هدوء لعقلك وروحك بعيداً عن ضجيج الحياة.
        </div>

        <a
          href="https://luma.com/fvf6fmbe"
          className="sticky-payment-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          Registration Link
          <span className="material-icons arrow-icon" aria-hidden="true">favorite</span>
        </a>

        <div style={{ direction: "rtl", textAlign: "right", marginBottom: "20px" }}>
          <p>
            أنا <strong>نُها كمّون</strong> أقدّم جلسة وعي وإرشاد مخصّصة للعناية بالصحة النفسية، سنعمل خلالها على تهدئة العقل، وتحرير المشاعر، وفهم طرق التعامل مع الخوف والغضب بوعي ولُطف.
        
            بعدها، شاركي في تجربة الرسم الإبداعي مع <strong>مروى هاشم</strong>، حيث تتحوّل الألوان إلى وسيلة للتعبير عن مشاعرك ورحلتك الخاصة.
</p><p>
 اللقاء مُصمّم خصيصًا لرائدات الأعمال اللاتي ترغبن بمساحة آمنة للتأمل، واستراحة من ضغوط الحياة، والتواصل مع أنفسهن بصدق.


          </p>
        </div>

        <img src={SaadaImg1} alt="Empowering Women Workshop" className="saada-image" />

        <div style={{ marginBottom: "20px", direction: "ltr", textAlign: "left" }}>
          <p>
            Pause from the hustle and join us for a guided wellness session with <strong>Noha Kammoun</strong>, designed to nurture your mind and spirit, followed by a creative painting experience with <strong>Marwa Hachem</strong> where you'll express your journey through art.
          </p>
          <p>
            This gathering is specifically designed for women entrepreneurs to reflect, recharge, and reconnect with themselves in a supportive environment.
          </p>
        </div>

        <h3 style={{ direction: "ltr", textAlign: "left" }}>🎤 Facilitator</h3>
        <div style={{ marginBottom: "20px", direction: "ltr", textAlign: "left" }}>
          <p>
            <strong>Noha Kammoun</strong> - Certified Life Coach (ICF + Heal Your Life®)
          </p>
          <p>
            Founder of Angel Coaching LLC.
          </p>
          <p>
            📞 <a href="tel:+13138585000">+1 313 858 5000</a>
          </p>
        </div>

        <h3 style={{ direction: "ltr", textAlign: "left" }}>📍 Location</h3>
        <div style={{ marginBottom: "20px", direction: "ltr", textAlign: "left" }}>
          <p>
            <strong>Marwa Hachem Fine Arts Studio</strong><br />
            13615 Michigan Ave, Dearborn, MI 48126
          </p>
        </div>

        <h3 style={{ direction: "ltr", textAlign: "left" }}>🗓️ Event Details</h3>
        <div style={{ marginBottom: "20px", direction: "ltr", textAlign: "left" }}>
          <p>
            <strong>Date:</strong> Saturday, October 18<br />
            <strong>Time:</strong> 6:00 PM - 8:00 PM
          </p>
        </div>

        <h3 style={{ direction: "ltr", textAlign: "left" }}>Partnership</h3>
        <div style={{ marginBottom: "20px", direction: "ltr", textAlign: "left" }}>
          <p>
            In cooperation between <strong>ACCESS</strong> and <strong>Angel Coaching LLC</strong>
          </p>
        </div>

      </div>

      <a
        href="https://luma.com/fvf6fmbe"
        className="center-btn"
        target="_blank"
        rel="noopener noreferrer"
      >
        Register Now
        <span className="material-icons arrow-icon" aria-hidden="true">favorite</span>
      </a>

    </section>
    </>
  );
}

export default EmpoweringWomen;
